import { io, Socket } from 'socket.io-client';
import { store } from '../store';
import { updateRenderStatus, updateSyncStatus } from '../store/tracksSlice';
import { API_BASE } from './api';

let socket: Socket | null = null;

export const getSocket = (): Socket | null => socket;

export const connectSocket = () => {
  if (socket?.connected) {
    return socket;
  }

  if (socket) {
    socket.connect();
    return socket;
  }

  socket = io(API_BASE, {
    auth: (cb) => {
      // Dynamically fetch the latest token from Redux store on connection/reconnection
      const currentToken = store.getState().auth.token;
      cb({ token: currentToken });
    },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('WebSocket connected:', socket?.id);
  });

  socket.on('authenticated', (data) => {
    console.log('WebSocket authenticated successfully for user:', data.userId);
  });

  socket.on('connect_error', (err) => {
    console.warn('WebSocket connection error:', err.message);
  });

  socket.on('render_status', (data) => {
    console.log('Received real-time render status update:', data);
    store.dispatch(updateRenderStatus(data));
  });

  socket.on('sync_status', (data) => {
    console.log('Received real-time sync status update:', data);
    store.dispatch(updateSyncStatus(data));
  });

  socket.on('disconnect', (reason) => {
    console.log('WebSocket disconnected:', reason);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
